import React, { useState } from "react";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../TCText/TCText";

export type FabOption = {
  id: number;
  title: string;
  onClick: () => void;
  backgroundColor?: string;
};

type ExpandableFABProps = {
  options: FabOption[];
  mainBackgroundColor?: string;
  mainTextColor?: string;
};

export const ExpandableFAB: React.FC<ExpandableFABProps> = ({
  options,
  mainBackgroundColor = Colors.darkBrown,
  mainTextColor = Colors.white,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "40px",
        right: "25px",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end", // Ensures everything aligns to the right
      }}>
      {/* Option buttons - shown only when expanded */}
      {isExpanded && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            marginBottom: "10px",
            gap: "10px",
            width: "100%", // Ensures the container takes full width
          }}>
          {options.map((option) => (
            <div
              key={option.id}
              onClick={() => {
                option.onClick();
                setIsExpanded(false); // Collapse after clicking an option
              }}
              style={{
                backgroundColor: option.backgroundColor || Colors.grey,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                padding: "10px 20px",
                borderRadius: "100px",
                opacity: 0,
                animation: "fadeIn 0.3s forwards",
                animationDelay: `${options.indexOf(option) * 0.1}s`,
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}>
              <TCText
                value={option.title}
                style={{ color: Colors.white, fontSize: 13 }}
              />
            </div>
          ))}
        </div>
      )}

      {/* Main button */}
      <div
        onClick={toggleExpand}
        style={{
          backgroundColor: isExpanded ? Colors.gold : mainBackgroundColor,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          padding: "10px 20px",
          borderRadius: "100px",
          width: "50px", // Fixed width to maintain consistent size
          height: "50px", // Fixed height to maintain consistent size
          alignSelf: "flex-end", // Ensures the button sticks to the right
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}>
        <TCText
          value={isExpanded ? "-" : "+"}
          style={{ color: mainTextColor, fontSize: 23 }}
        />
      </div>

      {/* CSS for animations */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};
